import { COLLEGE } from "../data/site";
import idcardLogo from "../assets/idcard-logo.png";
import principalSign from "../assets/idcard-principal-sign.png";
import "./IdCardVisual.css";

// Exact rules text from the uploaded reference file.
const RULES = {
  student: [
    "The student must carry and display the ID card while attending classes and on the institution's premises.",
    "The ID card is strictly personal and must not be shared, transferred, or misused by any other person.",
    "The student must immediately report any loss or damage of the ID card to the institution.",
    "Any alteration, duplication, or unauthorized use of the ID card is strictly prohibited and may lead to disciplinary action.",
  ],
  employee: [
    "Carry and display the ID Card visibly during college hours and official activities.",
    "The ID Card is non-transferable and must not be lent to any other person.",
    "Report immediately to the College Office if the ID Card is lost or damaged.",
    "Do not alter, tamper with, or misuse the ID Card.",
    "Return the ID Card to the College Office upon resignation, retirement, termination, or completion of service.",
  ],
};

const v = (x) => (x === undefined || x === null || String(x).trim() === "" ? "—" : x);

const PhotoPlaceholder = () => (
  <svg viewBox="0 0 100 120">
    <rect width="100" height="120" fill="#e4e8f0" />
    <circle cx="50" cy="44" r="22" fill="#b4bccd" />
    <path d="M8 120c0-30 18-46 42-46s42 16 42 46z" fill="#b4bccd" />
  </svg>
);

const ICONS = {
  pin: "M12 2a7 7 0 0 0-7 7c0 5 7 13 7 13s7-8 7-13a7 7 0 0 0-7-7zm0 9.5A2.5 2.5 0 1 1 12 6a2.5 2.5 0 0 1 0 5.5z",
  phone:
    "M6.6 10.8a15 15 0 0 0 6.6 6.6l2.2-2.2a1 1 0 0 1 1-.25 11 11 0 0 0 3.6.6 1 1 0 0 1 1 1V20a1 1 0 0 1-1 1A17 17 0 0 1 3 4a1 1 0 0 1 1-1h3.5a1 1 0 0 1 1 1c0 1.250.2 2.450.6 3.600a1 1 0 0 1-.25 1z",
  globe:
    "M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20zm6.900 9h-3a15 15 0 0 0-1.300-5.400A8 8 0 0 1 18.900 11zM12 4c.9 1.200 1.700 3.200 2 7H10c.3-3.800 1.100-5.800 2-7zM4.100 13h3a15 15 0 0 0 1.300 5.400A8 8 0 0 1 4.100 13zm3-2h-3a8 8 0 0 1 4.300-5.400A15 15 0 0 0 7.100 11zM12 20c-.9-1.200-1.700-3.200-2-7h4c-.3 3.800-1.100 5.800-2 7zm2.600-1.600A15 15 0 0 0 15.900 13h3a8 8 0 0 1-4.300 5.400z",
};
const Icon = ({ d }) => (
  <svg viewBox="0 0 24 24" fill="#f2b01e">
    <path d={d} />
  </svg>
);

function Field({ label, value }) {
  return (
    <div>
      <span>{label}</span>
      <b>{v(value)}</b>
    </div>
  );
}

function InactiveFlag({ show }) {
  if (!show) return null;
  return <div className="kccid-inactive">Not Active</div>;
}

export function CardFront({ data, college = COLLEGE }) {
  const employee = data.type === "employee";
  const parent = (data.father_name || "").trim();
  const courseSem = [data.course, data.semester].filter((x) => x && String(x).trim()).join(" / ");

  return (
    <div className={`idcard kccid-card ${employee ? "emp" : "stu"}`}>
      <InactiveFlag show={data.active === false} />
      <div className="kccid-side">
        <div className="kccid-photo">{data.photo ? <img src={data.photo} alt="card holder" /> : <PhotoPlaceholder />}</div>
        <div className="kccid-sigwrap">
          {data.signature ? <img src={data.signature} alt="holder signature" className="kccid-sig-img" /> : null}
          <div className="kccid-sig">Holder&rsquo;s signature</div>
        </div>
      </div>

      <div className="kccid-main">
        <div className="kccid-head">
          <div className="kccid-logo" style={{ backgroundImage: `url(${idcardLogo})` }} />
          <div className="kccid-role">
            <div className="kccid-cn">{(college.name || "Kanggui Christian College").toUpperCase()}</div>
            <span className="kccid-rt">{employee ? "Staff Identity Card" : "Student Identity Card"}</span>
            <small>
              {college.affiliation || "Affiliated to Manipur University"}
              <br />
              Affiliation no. {college.affNo || "MU/MU/P66/2005/DCD/737"}
            </small>
          </div>
        </div>

        <div className="kccid-name">{v(data.name)}</div>
        <div className="kccid-sd">
          <div>
            <span>Son / Daughter of</span>
            <b>{v(parent)}</b>
          </div>
        </div>

        {employee ? (
          <div className="kccid-g2">
            <Field label="Employee ID" value={data.card_no} />
            <Field label="Designation" value={data.designation} />
            <Field label="Department" value={data.department} />
            <Field label="Date of joining" value={data.doj} />
          </div>
        ) : (
          <div className="kccid-g2">
            <Field label="Registration No." value={data.card_no} />
            <Field label="Roll No." value={data.roll_no} />
            <Field label="Course / Semester" value={courseSem} />
            <Field label="Department" value={data.department} />
            <Field label="Session" value={data.session} />
            <Field label="ABC ID" value={data.abc_id} />
          </div>
        )}

        <div className="kccid-g3">
          <Field label="D.O.B" value={data.dob} />
          <Field label="Sex" value={data.sex} />
          <Field label="Blood group" value={data.blood_group} />
        </div>
      </div>

      <div className="kccid-foot" />
    </div>
  );
}

export function CardBack({ data, college = COLLEGE }) {
  const employee = data.type === "employee";
  const rules = employee ? RULES.employee : RULES.student;

  return (
    <div className={`idcard kccid-card kccid-back ${employee ? "emp" : "stu"}`}>
      <InactiveFlag show={data.active === false} />
      <div className="kccid-band">If found, please return to {college.name || "Kanggui Christian College"}, Kangpokpi</div>
      <div className="kccid-watermark" style={{ backgroundImage: `url(${idcardLogo})` }} />

      <div className="kccid-ad">
        <Field label="Permanent address" value={data.permanent_address} />
        <Field label="Present address" value={data.address} />
      </div>

      <div className="kccid-g4">
        <Field label="District" value={data.district} />
        <Field label="Pincode" value={data.pincode} />
        <Field label="Contact" value={data.phone} />
        <Field label="Identification mark" value={data.identification_mark} />
      </div>

      <div className="kccid-ins2">
        <b>{employee ? "ID Card Instructions" : "Instructions"}</b>
        <ol>
          {rules.map((r, i) => (
            <li key={i}>{r}</li>
          ))}
        </ol>
      </div>

      <div className="kccid-bot">
        <div className="kccid-bc">
          <div className="kccid-bar" />
          <div className="kccid-idn">{v(data.card_no)}</div>
        </div>
        <div className="kccid-psig">
          <div className="kccid-psg" style={{ backgroundImage: `url(${principalSign})` }} />
          <div className="kccid-line" />
          <b>Principal</b>
          <span>{college.principal || "Dr. Paokhohao Haokip"}</span>
        </div>
      </div>

      <div className="kccid-foot2">
        <div>
          <Icon d={ICONS.pin} />
          <span>{college.location || "Kangpokpi, Manipur"}</span>
        </div>
        <div>
          <Icon d={ICONS.phone} />
          <span>{college.phone || "8414809043"}</span>
        </div>
        <div>
          <Icon d={ICONS.globe} />
          <span>{college.website || "kangguichristiancollege.in"}</span>
        </div>
      </div>
    </div>
  );
}

export default function IdCardVisual({ data, college = COLLEGE }) {
  return (
    <div className="kccid-pair">
      <CardFront data={data} college={college} />
      <CardBack data={data} college={college} />
    </div>
  );
}
